import { render, staticRenderFns } from "./SucSelectComponent.vue?vue&type=template&id=bcf3bd6e&"
import script from "./SucSelectComponent.vue?vue&type=script&lang=js&"
export * from "./SucSelectComponent.vue?vue&type=script&lang=js&"
import style0 from "./SucSelectComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports